const config = {
  blogApiUrl: process.env.REACT_APP_API_BLOG_URL || '',
};

export const configuration = () => {
  if (!config.blogApiUrl) throw new Error('Please provide a blog api url!');

  return config;
};
